export function dataInRequest(params = {}) {
  return {
    type: '@alarmeSistema/DATA_IN_REQUEST',
    payload: { params },
  };
}

export function findData(id) {
  return {
    type: '@alarmeSistema/FIND_DATA',
    payload: { id },
  };
}

export function failedRequest() {
  return {
    type: '@alarmeSistema/FAILED_REQUEST',
  };
}

export function deleteData(id, params) {
  return {
    type: '@alarmeSistema/DELETE_DATA',
    payload: { id, params },
  };
}

export function updateData(data, params) {
  return {
    type: '@alarmeSistema/UPDATE_DATA',
    payload: { data, params },
  };
}

export function storeData(data, params) {
  return {
    type: '@alarmeSistema/STORE_DATA',
    payload: { data, params },
  };
}

export function successInRequest(data, page, pageSize, totalCount, totalPages) {
  return {
    type: '@alarmeSistema/SUCCESS_IN_REQUEST',
    payload: { data, page, pageSize, totalCount, totalPages },
  };
}

export function successRequest(data) {
  return {
    type: '@alarmeSistema/SUCCESS_REQUEST',
    payload: { data },
  };
}

export function successRemove(params) {
  return {
    type: '@alarmeSistema/SUCCESS_REMOVE',
    payload: { params },
  };
}

export function recordFiltering(params) {
  return {
    type: '@alarmeSistema/RECORD_FILTERING',
    payload: { params },
  };
}
